import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function EducationSection() {
  return <section className="flex flex-col lg:flex-row min-h-[600px]" data-id="element-102">
      {/* Left Content Side */}
      <div className="w-full lg:w-1/2 bg-[#0A5E5C] p-10 md:p-16 lg:p-24 flex flex-col justify-center text-white" data-id="element-103">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-104">
          Education and Training
        </h2>

        <p className="text-white/80 text-lg mb-10 leading-relaxed" data-id="element-105">
          Education is the key to safe and fair play. We have developed a series
          of educational webinars and programs to raise awareness of risks and
          the principles of responsible gambling. Our courses help people
          understand how the industry works, what risks it may carry, and how to
          minimize them.
        </p>

        <ul className="space-y-4 mb-12" data-id="element-106">
          {['Player Rights Protection', 'Educational Information for Parents', 'Responsible Gambling', 'How the Gambling Market Works'].map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-107">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#D4A843] flex items-center justify-center text-[#0A5E5C]" data-id="element-108">
                <Check size={14} strokeWidth={3} data-id="element-109" />
              </div>
              <span className="text-lg font-medium" data-id="element-110">{item}</span>
            </li>)}
        </ul>

        <div data-id="element-111">
          <Button variant="secondary" size="lg" data-id="element-112">
            Explore Our Courses
          </Button>
        </div>
      </div>

      {/* Right Image Side */}
      <div className="w-full lg:w-1/2 relative min-h-[400px]" data-id="element-113">
        <img src="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1000&h=1000&fit=crop&q=80" alt="Person walking on a forest path" className="absolute inset-0 w-full h-full object-cover" data-id="element-114" />
        <div className="absolute inset-0 bg-[#0A5E5C]/20 mix-blend-multiply" data-id="element-115" />
      </div>
    </section>;
}